module.exports = __webpack_public_path__ + "static/media/SAINT_3121.8aabe1ad.jpg";